import { render, staticRenderFns } from "./add-activity.vue?vue&type=template&id=ca38b766&scoped=true"
import script from "./add-activity.vue?vue&type=script&lang=js"
export * from "./add-activity.vue?vue&type=script&lang=js"
import style0 from "./add-activity.vue?vue&type=style&index=0&id=ca38b766&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca38b766",
  null
  
)

export default component.exports